import clsx from "~/util/html/style";

type Props = {
  filledPercentage: number;
  class?: string;
  size?: "xs" | "sm" | "md";
  tone?: "primary" | "success";
};

const SIZE = { xs: "h-0.5", sm: "h-1.5", md: "h-3" };
const TONE = { primary: "bg-brand-primary", success: "bg-brand-success" };

export function ProgressBar(props: Props) {
  return (
    <div class={props.class} style={{ "--filled-percentage": `${props.filledPercentage}%` }}>
      <div
        class={clsx(
          "relative w-full overflow-hidden rounded-full bg-brand-light",
          SIZE[props.size ?? "md"],
        )}
      >
        <div
          class={clsx(
            "absolute top-0 left-0 h-full w-(--filled-percentage) transition-[width]",
            TONE[props.tone ?? "primary"],
          )}
        />
      </div>
    </div>
  );
}
